// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.physical-domain {
  display: flex;
  width: 100%; 
  height: 100vh; 
  background: var(--Neutral-50, #F8FAFC);
}

.sidebar-domain{
  display: flex;
  flex-direction: column;
  gap: 1rem; 
  /* position: fixed; */
}

.questioncard-domain{
  display: flex;
  padding-bottom: 1.5rem; 
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 1 auto;
  align-self: stretch;
  background: var(--Neutral-50, #F8FAFC);
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/screens/Assessment/Components/PhysicalDomain.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,sCAAsC;EACtC,WAAW;AACb","sourcesContent":[".physical-domain {\n  display: flex;\n  width: 100%; \n  height: 100vh; \n  background: var(--Neutral-50, #F8FAFC);\n}\n\n.sidebar-domain{\n  display: flex;\n  flex-direction: column;\n  gap: 1rem; \n  /* position: fixed; */\n}\n\n.questioncard-domain{\n  display: flex;\n  padding-bottom: 1.5rem; \n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex: 1 1 auto;\n  align-self: stretch;\n  background: var(--Neutral-50, #F8FAFC);\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
